import { render, staticRenderFns } from "./training_abnormal.vue?vue&type=template&id=94fc0dca&scoped=true&"
import script from "./training_abnormal.vue?vue&type=script&lang=js&"
export * from "./training_abnormal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94fc0dca",
  null
  
)

export default component.exports